import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { CtaSessionIcon, MdOutlineArrowRightAlt, Stethoscope } from '../../icons';
import './css/automatedCTA.scss';
import queryString from 'query-string';
import { content_cta_suscribe_speciality_v1_static_image } from '../../../common/assets.common';
const CtaSubscribeSpecialityV1 = ({ data, onClickCallback, isSubscribed, position }) => {
  const { pathname, search } = useLocation();
  const { id } = queryString.parse(search);
  return (
    <div
      className={`w-100 subsSpecialityCTABoxV1 position-relative overflow-hidden shadow p-5 rounded-3 ${
        position == 'after_related' || position == 'before_related' ? 'inSidebar' : ''
      }`}
    >
      <img
        src={content_cta_suscribe_speciality_v1_static_image}
        className="ctaCardBoxBg object-fit-cover w-100 h-100 float-start"
      />
      <div className="ctaCardBoxIn d-flex justify-content-between align-items-center">
        <div className="ctaCardDetails text-start">
          <h4 className="fs-3 text-white fw-semibold mb-3 position-relative">
            Loving the latest reads on <span className="fs-2">{data?.speciality}?</span>
          </h4>
          <h6 className="fs-4 fw-medium text-white">
            Always be updated on {data?.speciality}'s trending topics! Get fresh reads delivered
            directly to your device. Opt out with a single click.
          </h6>
        </div>
        <div className="ctaCardBtn">
          <button
            className="btn btn-secondary fs-4 d-flex align-items-center justify-content-center shadow fw-medium rounded-pill cursorPointer ctaLink"
            disabled={isSubscribed}
            onClick={() =>
              onClickCallback(
                data?.id,
                data?.cta_type_id,
                data?.entity_id,
                data?.entity_value,
                3,
                pathname,
                id
              )
            }
          >
            {isSubscribed ? 'Subscribed' : 'Subscribe Now'}{' '}
            <MdOutlineArrowRightAlt customClass={'fs-4 ms-2 '} />
          </button>
        </div>
      </div>
      <Stethoscope customClass={'fs-72 text-secondary cardSvgIcon'} />
    </div>
  );
};

export default memo(CtaSubscribeSpecialityV1);
